<template>
  <nav className="w-full flex flex-wrap items-center justify-end md:justify-between md:gap-4 py-2 px-4 lg:py-4 lg:px-16 text-white">
    <NuxtLink to="/" class="flex items-center">
      <img
        src="~/assets/svg/albarraWoods.svg"
        alt="albarra"
        class="h-3 lg:h-8 w-auto" />
    </NuxtLink>

    <div class="flex flex-1 items-center justify-evenly font-semibold text-xl">
      <NuxtLink
        to="/quests"
        :class="{
          'opacity-50': $route.path != '/quests',
        }"
      >
        <Typography size="main-md">Quests</Typography>
      </NuxtLink>
      <NuxtLink
        to="/leaderboard"
        :class="{
          'opacity-50': $route.path != '/leaderboard',
        }"
      >
        <Typography size="main-md">Leaderboard</Typography>
      </NuxtLink>
      <div class="relative">
        <div
          :class="{
            'w-3 h-3 z-40 animate-ping bg-primary rounded-full top-0 left-0 absolute': true,
            hidden: !hasBadgeNotification,
          }"
        ></div>
        <NuxtLink
          to="/badges"
          class="flex items-center gap-2"
        >
          <Typography size="main-md" :class="{ 'opacity-50': $route.path != '/badges' }">Badges</Typography>
          <img v-if="hasApecoin"
              src="../assets/images/apecoin_logo.png"
              alt="badge claimed"
              class="w-6" />
        </NuxtLink>
      </div>
    </div>
    <div class="w-100 md:w-auto flex items-center justify-between gap-1 lg:gap-6 text-3xl font-extrabold">
      <span class="flex items-center gap-2">
        <img
          src="~/assets/svg/troncos.svg"
          alt="woods"
          class="w-4 h-4 md:w-6 md:h-6 lg:w-11 lg:h-11"
        />
        <span class="flex items-center justify-center">
          <Typography
            size="main-l"
            class="!text-4xl lg:!text-7xl leading-none"
            >{{ logsTotal }}</Typography
          >
        </span>
      </span>
      <div class="h-8 lg:h-12 w-px bg-neutral-500"></div>

      <!-- DAILY STREAK -->
      <DailyClaim />
      <!-- END DAILY STREAK -->

      <!-- NOTIFICATIONS -->
      <Notifications />
      <!-- END NOTIFICATIONS -->
      <div
        v-if="auth.isAuthenticated && isClient"
        :class="{
          ' relative h-12 flex items-center justify-center gap-2  select-none ': true,
          'border-b-0 rounded-b-none': navIsOpen,
        }"
      >
        <div
          class="flex gap-2 items-center justify-center py-2 px-2 rounded rounded-t cursor-pointer border border-primary"
          @click="toggleNav"
        >
          <img :src="auth.twitterPhoto" class="w-5 h-5 md:w-6 md:h-6 rounded-full" />

          <Typography size="main-md" class="text-center whitespace-no-wrap">{{
            `@${auth.twitterNickName}`
          }}</Typography>
          <span class="rounded-full"><LucideChevronDown /></span>
        </div>
        <div
          v-if="navIsOpen"
          class="flex rounded-b flex-col z-40 absolute p-4 top-0 mt-12 w-full gap-3 bg-black border border-primary border-t-0"
        >
          <div
            v-if="auth.otherPage"
            class="flex gap-4 justify-items-center justify-start"
            :key="otherPage"
          >
            <a :href="`https://other.page/u/${auth.otherPage}`" target="_blank">
              <img src="/other_page.svg" alt="Other Page" class="w-6 h-6 bg-black rounded-full" />
            </a>
            <button
              @click="openOtherPageModal"
              class="flex items-center gap-2 cursor-pointer"
            >
              <Typography size="main-md">Edit</Typography>
            </button>
          </div>
          <div
            v-else
            @click="openOtherPageModal"
            class="flex items-center gap-2 cursor-pointer"
          >
            <LucideLink />
            <Typography size="main-md">Link Other Page</Typography>
          </div>
          <div
          v-if="auth.theRailCode"
            @click="openTheRailCodeModal"
            class="flex items-center gap-2 cursor-pointer"
          >
            <Typography size="main-md">The Rail Code</Typography>
          </div>
          <!--
          <div class="h-px w-full bg-neutral-700"></div>
          <Typography class="text-center">Total interactions</Typography>
          <div class="flex gap-2 justify-around">
            <div class="flex flex-col gap-2 items-center">
              <LucideHeart />
              <p class="font-bold text-xl text-primary">145</p>
            </div>
            <div class="flex flex-col gap-2 items-center">
              <LucideMessageCircle />
              <p class="font-bold text-xl text-primary">145</p>
            </div>
            <div class="flex flex-col gap-2 items-center">
              <LucideRepeat2 />
              <p class="font-bold text-xl text-primary">145</p>
            </div>
          </div>
          -->
          <div class="h-px w-full bg-neutral-700"></div>
          <div
            class="flex items-center text-lg gap-4 cursor-pointer"
            @click="logout"
          >
            <LucideLogOut /> Logout
          </div>
        </div>
      </div>
      <div
        v-else
        @click="login"
        :class="{
          'border relative rounded rounded-t  lg:h-12 p-1 px-2 border-primary lg:py-2 lg:px-4 flex items-center justify-center gap-2 cursor-pointer ': true,
          'border-b-0 rounded-b-none': navIsOpen,
        }"
      >
        <Typography size="main-md" class="text-center whitespace-no-wrap"
          >Log in with
        </Typography>
        <span class="rounded-full"
          ><img
            src="~/assets/svg/x-logo-twiter.svg"
            class="w-4 h-4 lg:w-6 lg:h-6 rounded-full"
        /></span>
      </div>
    </div>

    <!--
    <span class="flex justify-center items-center gap-2 md:hidden">
      <img src="~/assets/svg/troncos.svg" alt="woods" class="w-6 h-6" />
      <Typography size="main-l">{{ logsTotal }}</Typography>
    </span>
    <div class="md:hidden"
        @click="toggleNav">
      <LucideMenu class="text-primary" />
    </div>
    -->
  </nav>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import Typography from "./common/Typography.vue";
import { useAuthStore } from "../stores/useAuthStore";
import { cmsStore } from "../stores/cmsStore";
import { useModalsStore } from "../stores/useModalsStore";

const auth = useAuthStore();
const cms = cmsStore();
const modal = useModalsStore();

const logsTotal = computed(() => cms.getLogsTotal);
const hasBadgeNotification = computed(() => cms.hasClaimBadgeNotifications);
const hasApecoin = computed(() => cms.hasApeCoinOnBadges);
// authentication
const login = () => auth.login();
const logout = () => auth.logout();
const openOtherPageModal = () => modal.openModal("LINK_OTHER_PAGE");
const openTheRailCodeModal = () => modal.openModal("THE_RAIL_CODE");

// notifications
const navIsOpen = ref(false);

const isClient = ref(false);

const toggleNav = () => {
  navIsOpen.value = !navIsOpen.value;
};

onMounted(() => {
  isClient.value = true;
  cms.updateNotifications;
});
</script>
